jQuery(document).ready(function ($) {
  const swiper = new Swiper(".partners-carousel-swiper", {
    slidesPerView: 1.5,
    centerInsufficientSlides: true,
    spaceBetween: 16,
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 2.5,
      },
      580: {
        slidesPerView: 2.5,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 5,
      },
      1280: {
        slidesPerView: 6,
      },
    },
  });
});
